import type { LcVideoDataResponse } from '@/api/lcLearning'

export type LibraryVideoReviewMode = 'video_only' | 'video_with_block_quiz'

/**
 * 도서관 영상 복습 모드를 프런트에서만 적용한다.
 * 원본 payload는 변경하지 않아 모드 전환 시 다시 요청할 필요가 없다.
 */
export function applyLibraryVideoReviewMode(
  videoData: LcVideoDataResponse,
  mode: LibraryVideoReviewMode,
): LcVideoDataResponse {
  if (mode === 'video_with_block_quiz') return videoData
  return { ...videoData, pauseAndGoPoints: [] }
}
